export default{
  methods: {
    bytesToSize(bytes) {
      const SIZES = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${this.$t('files.size.' + SIZES[i].toLocaleLowerCase())}`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${this.$t('files.size.' + SIZES[i].toLocaleLowerCase())}`
    },
    fileNameCut(fileName = '', length = 25, notReplace = true){

      if(notReplace){

        fileName = fileName.replace(/\.[^.]+$/, "")
      }

      let nameLength = fileName.length

      return  (nameLength <= length) ? fileName : fileName.substr(0, 15) + '...' + fileName.substr(nameLength - 7, 7)
    },
    isGcodeFileType(fileTypeId) {
      return fileTypeId == 2;
    },
    isStlFileType(fileTypeId) {
      return fileTypeId == 1;
    }
  }
}
